import { each, isArray, isEmpty, isString } from "lodash-es";
import { isBeacon, beaconMask, transformBeacon, restoreBeacon } from "./beacon";
import { isComma, restoreComma, transformComma } from "./comma";
import { isComNum, restoreComNum, transformComNum } from "./comNum";
import { isEmail } from "./email";
import { isImage } from "./image";
import { isJumin, restoreJumin, transformJumin } from "./jumin";
import { isMobile, isMobileWithAsterisk, restoreMobile, restoreMobileWithAsterisk, transformMobile, transformMobileWithAsterisk } from "./mobile";
import { isNumber, restoreNumber, transformNumber } from "./number";
import { isPositive, transPositive } from "./positive";
import { transformZeroToUndefined } from "./zeroToUndefined";

const defulatUnvalidText = '올바르지 않은 값입니다.';

// validator의 경우 서로 상충되는 값이 있을 수 있으니 주의할것
/*---
  {
    type: 'type',
    label: 'label',
    unvalidText?: 'unvalid message',
    validator?: 벨리데이션 함수,
    mask?: 마스크 스트링,
    transform?: transfomr 함수,
    restore?: restore 함수,
  }
---*/
const validators = [
  {
    type: 'zeroToUndefined',
    label: '숫자0을undefined로변환',
    validator: () => true,
    transform: transformZeroToUndefined,
  },
  {
    type: 'positive',
    label: '정수',
    unvalidText: '은(는) 0보다 커야합니다.',
    validator: isPositive,
    transform: transPositive,
  },
  {
    type: 'image',
    label: '필수',
    unvalidText: '은(는) 필수입니다.',
    validator: isImage,
  },
  {
    type: 'required',
    label: '필수',
    unvalidText: '은(는) 필수입니다.',
    validator: (val) => {
      return !isEmpty(val);
    },
  },
  {
    type: 'number',
    label: '숫자',
    unvalidText: '은(는) 숫자입니다.',
    validator: isNumber,
    transform: transformNumber,
    restore: restoreNumber,
  },
  {
    type: 'comma',
    label: '콤마',
    unvalidText: '은(는) 숫자입니다.',
    validator: isComma,
    transform: transformComma,
    restore: restoreComma,
  },
  {
    type: 'mobile',
    label: '핸드폰',
    unvalidText: '은(는) 숫자로 10~12자리 입니다.',
    validator: isMobile,
    transform: transformMobile,
    restore: restoreMobile,
  },
  {
    type: 'mobileWithAsterisk',
    label: '연락처',
    unvalidText: '은(는) 숫자로 9~12자리 입니다.',
    validator: isMobileWithAsterisk,
    transform: transformMobileWithAsterisk,
    restore: restoreMobileWithAsterisk,
  },
  {
    type: 'beacon',
    label: '비콘',
    unvalidText: '은(는) A~F, 숫자 32자리입니다.',
    validator: isBeacon,
    mask: beaconMask,
    transform: transformBeacon,
    restore: restoreBeacon,
  },
  {
    type: 'comNum',
    label: '사업자등록번호',
    unvalidText: '은(는) 10자리 숫자입니다.',
    validator: isComNum,
    transform: transformComNum,
    restore: restoreComNum,
  },
  {
    type: 'jumin',
    label: '주민/외국인등록번호',
    unvalidText: '은(는) 13자리 숫자입니다.',
    validator: isJumin,
    transform: transformJumin,
    restore: restoreJumin,
  },
  {
    type: 'email',
    label: '이메일',
    unvalidText: '형식이 아닙니다.',
    validator: isEmail,
  },
];

// 벨리데이터 가져오기
const getValidator = (type) => {
  return validators.find(v => v.type === type);
};

// 유효성 검사
const isValid = (value, type) => {
  const validator = getValidator(type);
  return validator && validator.validator(value);
};

// 유효하지 않았을떄의 텍스트 반환 요청 '값을 넣지 않기 때문에 무조건 반환' 
const getUnvalidText = (title, type) => {
  const validator = getValidator(type);
  return `${title ? `${title} ` : ''} ${validator && validator.unvalidText ? validator.unvalidText : defulatUnvalidText}`;
};

// 에러 세팅 errors 를 넣으면 주소 복사 안넣어도 return
const getValidatorErros = (value = '', validators, title = '', errors = []) => {
  if (isString(validators)) {
    if (!isValid(value, validators)) {
      errors.push(getUnvalidText(title, validators));
    }
  } else if (isArray(validators)) {
    each(validators, (validator) => {
      getValidatorErros(value, validator, title, errors);
    });
  }
  return errors;
};

// type 에 맞게 변환
// types에 입력된 순서대로 변환 됨
const transform = (value, type) => {
  if (isArray(type)) {
    each(type, (t) => {
      value = transform(value, t);
    });
  }
  const validator = getValidator(type);
  return validator && validator.transform ? validator.transform(value) : value;
};

// 변환 원상 복구
// types에 입력된 순서대로 복구 됨
const restore = (value, type = '') => {
  if (isArray(type)) {
    each(type, (t) => {
      value = restore(value, t);
    });
  }
  const validator = getValidator(type);
  return validator && validator.restore ? validator.restore(value) : value;
};

export default validators;
export {
  validators, getValidator, isValid, getUnvalidText, transform, restore,
  getValidatorErros, // validator 기본
  isBeacon, beaconMask, // beacon
  isNumber
};